import { lazy } from "react";
import { LineChart } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

export const analyticsFeature: FeatureDescriptor = {
  id: "analytics",
  flag: "analytics",
  path: "/analytics",
  group: "analyse",
  navKey: "nav.analytics",
  icon: LineChart,
  roles: ["admin", "manager", "analyst"], // mirrors the backend analytics guard
  element: lazy(() => import("./AnalyticsPage")),
  scope: { locality: true, days: true },
};
